/* sf-theme.js — behaviour for the store pages.
   The homepage sections are driven by sf-homepage-2025.js; this file covers
   the product page, collection sorting, cart and account forms. */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Product page: gallery
     ---------------------------------------------------------------------- */
  function initGallery() {
    var main = document.getElementById('sf-pdp-main');
    var thumbs = document.querySelectorAll('.sf-pdp__thumb');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (!src) return;
        main.src = src;
        main.removeAttribute('srcset');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Product page: variant picker
     Matches the selected option values against the variant list rendered
     into the page as JSON, then updates the hidden id, price and button.
     ---------------------------------------------------------------------- */
  function initVariants() {
    var form = document.getElementById('sf-pdp-form');
    var data = document.querySelector('[data-sf-variants]');
    if (!form || !data) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-sf-option-index]');
    var input = form.querySelector('[data-sf-variant-input]');
    var submit = form.querySelector('[data-sf-pdp-submit]');
    var submitText = form.querySelector('[data-sf-submit-text]');
    var priceEl = document.getElementById('sf-pdp-price');
    if (!selects.length || !input) return;

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function money(cents) {
      // Shopify money format varies by shop; fall back to the shop's own
      // formatting when the page exposes it, otherwise a plain 2dp figure.
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return (cents / 100).toFixed(2);
    }

    function update() {
      var variant = findVariant(currentOptions());

      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      input.value = variant.id;

      if (submit) submit.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (priceEl) {
        var html = '<span class="sf-price' + (variant.compare_at_price > variant.price ? ' sf-price--sale' : '') + '">' +
                   '<span class="sf-price__now">' + money(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += '<s class="sf-price__was">' + money(variant.compare_at_price) + '</s>' +
                  '<span class="sf-price__badge">Sale</span>';
        }
        priceEl.innerHTML = html + '</span>';
      }

      // Keep the URL shareable without reloading.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  /* ----------------------------------------------------------------------
     Quantity steppers (product page and cart)
     ---------------------------------------------------------------------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-sf-qty]');
      if (!btn) return;
      var wrap = btn.closest('.sf-qty');
      var input = wrap && wrap.querySelector('.sf-qty__input');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-sf-qty'), 10) || 0;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      var next = (parseInt(input.value, 10) || min) + step;
      input.value = next < min ? min : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ----------------------------------------------------------------------
     Collection sorting — submit on change
     ---------------------------------------------------------------------- */
  function initSort() {
    var sort = document.querySelector('[data-sf-sort]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ----------------------------------------------------------------------
     Cart: keep the header count in sync after an AJAX add
     ---------------------------------------------------------------------- */
  function initCartCount() {
    document.addEventListener('cart:refresh', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.sf-iconbtn__count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    });
  }

  /* ----------------------------------------------------------------------
     Address form: country / province linkage + delete confirmation
     ---------------------------------------------------------------------- */
  function initAddresses() {
    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      document.querySelectorAll('select[name="address[country]"]').forEach(function (sel, i) {
        var province = sel.closest('.sf-form__row').querySelector('select[name="address[province]"]');
        if (!province) return;
        sel.id = sel.id || 'sf-country-' + i;
        province.id = province.id || 'sf-province-' + i;
        new window.Shopify.CountryProvinceSelector(sel.id, province.id, {
          hideElement: province.parentNode
        });
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-confirm-delete]');
      if (!btn) return;
      if (!window.confirm('Delete this address?')) e.preventDefault();
    });
  }

  function init() {
    initGallery();
    initVariants();
    initQuantity();
    initSort();
    initCartCount();
    initAddresses();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

